<template>
    <div ref="btnElement" class="remover" :class="{ disabled: disabled }" :disabled="disabled">
        <div class="outer"><i class="fal fa-trash-alt"></i></div>
    </div>
</template>

<script setup lang="ts">
    import { Ripple } from "@/shared/ui/Ripple";
    import { onMounted, ref } from "vue";

    defineProps<{
        disabled?: boolean;
    }>();

    const btnElement = ref<HTMLButtonElement>();

    onMounted(() => {
        Ripple.bindRippleOut($(btnElement.value!), "> .outer");
    });
</script>
